import { LEGAL_OPERATOR, LEGAL_SITE, YOOKASSA } from "./legalMeta";

export const PRIVACY_SECTIONS = [
  {
    key: "general",
    title: "Общие положения",
    summary: "Назначение политики и согласие Пользователя.",
    data: [
      {
        point: 1,
        text: `Настоящая Политика конфиденциальности определяет порядок обработки и защиты персональных данных пользователей сервиса ${LEGAL_SITE.name} (${LEGAL_SITE.url}).`,
      },
      {
        point: 2,
        text: `Оператор персональных данных: ${LEGAL_OPERATOR.status} ${LEGAL_OPERATOR.name}, ИНН ${LEGAL_OPERATOR.inn} (далее — «Оператор»).`,
      },
      {
        point: 3,
        text: "Использование Сайта означает согласие Пользователя с настоящей Политикой. При несогласии с условиями необходимо прекратить использование сервиса.",
      },
    ],
  },
  {
    key: "data-categories",
    title: "Состав обрабатываемых данных",
    summary: "Какие данные могут обрабатываться при работе с сервисом.",
    data: [
      {
        point: 1,
        text: "Регистрационные данные: адрес электронной почты, идентификатор аккаунта, дата регистрации.",
      },
      {
        point: 2,
        text: "Платёжные сведения: информация о заказах и статусе оплаты. Реквизиты банковских карт обрабатываются платёжным провайдером и не хранятся Оператором.",
      },
      {
        point: 3,
        text: "Технические данные: IP-адрес, тип браузера и устройства, cookies, журналы действий на Сайте, сведения об ошибках.",
      },
      {
        point: 4,
        text: "Контент, который Пользователь добровольно загружает в сценарии: тексты, видео, изображения и иные материалы.",
      },
      {
        point: 5,
        text: "Оператор не обрабатывает специальные категории персональных данных (о здоровье, биометрии, политических взглядах и т.п.), если Пользователь самостоятельно не размещает их в контенте.",
      },
    ],
  },
  {
    key: "purposes",
    title: "Цели обработки",
    summary: "Для чего используются персональные данные.",
    data: [
      {
        point: 1,
        text: "Регистрация, идентификация и авторизация Пользователя на Сайте.",
      },
      {
        point: 2,
        text: "Предоставление доступа к функционалу платформы, ключам и оплаченным услугам.",
      },
      {
        point: 3,
        text: "Обработка платежей, учёт заказов и истории операций.",
      },
      {
        point: 4,
        text: "Техническая поддержка, ответы на обращения и информирование об изменениях сервиса.",
      },
      {
        point: 5,
        text: "Обеспечение безопасности, предотвращение мошенничества и нарушений Правил сервиса.",
      },
      {
        point: 6,
        text: "Исполнение требований законодательства Российской Федерации.",
      },
    ],
  },
  {
    key: "legal-basis",
    title: "Правовые основания",
    summary: "На каком основании обрабатываются данные.",
    data: [
      {
        point: 1,
        text: "Федеральный закон от 27.07.2006 № 152-ФЗ «О персональных данных».",
      },
      {
        point: 2,
        text: "Согласие субъекта персональных данных, выраженное при регистрации и использовании Сайта.",
      },
      {
        point: 3,
        text: "Необходимость исполнения договора (публичной оферты), стороной которого является Пользователь.",
      },
      {
        point: 4,
        text: "Законные интересы Оператора по обеспечению работоспособности и безопасности сервиса.",
      },
    ],
  },
  {
    key: "storage",
    title: "Сроки хранения",
    summary: "Как долго хранятся персональные данные.",
    data: [
      {
        point: 1,
        text: "Данные хранятся до достижения целей обработки или до отзыва согласия Пользователем, если иное не требуется законом.",
      },
      {
        point: 2,
        text: "Сведения об оплатах и бухгалтерские документы могут храниться в сроки, установленные налоговым и гражданским законодательством РФ.",
      },
      {
        point: 3,
        text: "Технические логи хранятся ограниченный срок, необходимый для диагностики и обеспечения безопасности.",
      },
    ],
  },
  {
    key: "third-parties",
    title: "Передача третьим лицам",
    summary: "Кому могут передаваться данные и в каких случаях.",
    data: [
      {
        point: 1,
        text: `Платёжному провайдеру ${YOOKASSA.name} — в объёме, необходимом для проведения и подтверждения платежей.`,
      },
      {
        point: 2,
        text: "Хостинг-провайдерам и подрядчикам — для технического обеспечения работы Сайта, при условии соблюдения конфиденциальности.",
      },
      {
        point: 3,
        text: "Государственным органам — в случаях, предусмотренных законодательством РФ, на основании надлежащего запроса.",
      },
      {
        point: 4,
        text: "Оператор не продаёт персональные данные и не передаёт их третьим лицам в маркетинговых целях без отдельного согласия.",
      },
    ],
  },
  {
    key: "cookies",
    title: "Файлы cookies",
    summary: "Использование cookies и управление ими.",
    data: [
      {
        point: 1,
        text: "Сайт использует cookies и аналогичные технологии для авторизации, сохранения настроек, обеспечения безопасности и сбора обезличенной статистики.",
      },
      {
        point: 2,
        text: "Пользователь может ограничить или отключить cookies в настройках браузера. Отключение может повлиять на доступность отдельных функций Сайта.",
      },
    ],
  },
  {
    key: "security",
    title: "Защита данных",
    summary: "Меры по обеспечению безопасности.",
    data: [
      {
        point: 1,
        text: "Оператор применяет организационные и технические меры защиты персональных данных от неправомерного доступа, уничтожения, изменения и распространения.",
      },
      {
        point: 2,
        text: "Доступ к данным имеют только уполномоченные лица, обязанные соблюдать конфиденциальность.",
      },
    ],
  },
  {
    key: "rights",
    title: "Права субъекта данных",
    summary: "Права Пользователя в соответствии с ФЗ-152.",
    data: [
      {
        point: 1,
        text: "Получать информацию об обработке своих персональных данных.",
      },
      {
        point: 2,
        text: "Требовать уточнения, блокирования или уничтожения данных, если они неполные, устаревшие или обрабатываются незаконно.",
      },
      {
        point: 3,
        text: "Отозвать согласие на обработку персональных данных, направив обращение Оператору.",
      },
      {
        point: 4,
        text: "Обжаловать действия или бездействие Оператора в Роскомнадзор или в судебном порядке.",
      },
      {
        point: 5,
        text: "Отзыв согласия может повлечь невозможность дальнейшего использования Сайта, если обработка необходима для исполнения договора.",
      },
    ],
  },
  {
    key: "cross-border",
    title: "Трансграничная передача",
    summary: "Передача данных за пределы РФ.",
    data: [
      {
        point: 1,
        text: "Оператор не осуществляет целенаправленную трансграничную передачу персональных данных, за исключением случаев, когда это необходимо для работы инфраструктурных сервисов и допускается законодательством РФ.",
      },
    ],
  },
  {
    key: "contacts",
    title: "Контактная информация",
    summary: "Куда обращаться по вопросам персональных данных.",
    data: [
      {
        point: 1,
        text: `Email: ${LEGAL_OPERATOR.email}. Telegram: ${LEGAL_OPERATOR.telegram}.`,
      },
      {
        point: 2,
        text: `Оператор: ${LEGAL_OPERATOR.status} ${LEGAL_OPERATOR.name}, ИНН ${LEGAL_OPERATOR.inn}.`,
      },
      {
        point: 3,
        text: "Срок рассмотрения обращений — до 30 календарных дней, если иной срок не установлен законом.",
      },
    ],
  },
  {
    key: "final",
    title: "Заключительные положения",
    summary: "Изменение политики и актуальная версия.",
    data: [
      {
        point: 1,
        text: "Оператор вправе изменять настоящую Политику в одностороннем порядке с публикацией новой редакции на Сайте.",
      },
      {
        point: 2,
        text: "Новая редакция вступает в силу с момента размещения на Сайте, если иное не указано в тексте изменений.",
      },
      {
        point: 3,
        text: "Актуальная версия Политики доступна по адресу /politic-confidencial.",
      },
    ],
  },
];
